import React, { useContext, useRef, useEffect } from "react";
import { MediaContext } from "../../context/MediaContext";
import MediaCard from "../MediaCard/MediaCard";

const UserVideo = () => {
  const {
    localVideoTrack,
    audioEnabled,
    videoEnabled,
    setAudioEnabled,
    setVideoEnabled,
  } = useContext(MediaContext);

  const videoRef = useRef(null);
  const audioRef = useRef(null);

  useEffect(() => {
    const el = videoRef.current;
    if (!el || !localVideoTrack) return;

    try {
      localVideoTrack.attach(el);
    } catch (e) {
      console.error("[UserVideo] attach failed:", e);
    }

    return () => {
      try {
        // detach() with no args is safest; it returns the detached elements
        localVideoTrack.detach().forEach((n) => {
          try {
            if (n && n.srcObject) n.srcObject = null;
          } catch (_) {}
        });
      } catch (_) {}
    };
  }, [localVideoTrack]);

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <MediaCard
        audioRef={audioRef}
        videoRef={videoRef}
        type="local"
        audioEnabled={audioEnabled}
        videoEnabled={videoEnabled}
        setAudioEnabled={setAudioEnabled}
        setVideoEnabled={setVideoEnabled}
      />
    </div>
  );
};

export default UserVideo;
